import React from 'react';
import MainPage from '../Components/Shared/MainPage';
import LoadingSpinner from '../Components/Common/LoadingSpinner';
import { get } from '../Code/IApi';
import { parseQuerystring } from '../Code/Utilities';

export default class DynamicPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageData: null,
      loading: false,
      errMsg: null,
    };
  }

  async componentDidMount() {
    const qsVariables = parseQuerystring(window.location.search);
    if (qsVariables.page) {
      this.setState({ loading: true, errMsg: null });
      const response = await get(
        `/generalUtils/dynamicContent/${qsVariables.page}`
      );
      this.setState({
        loading: false,
        pageData: response.Content,
        errMsg: response.ErrorMessage,
      });
    }
  }

  render() {
    const { loading, pageData, errMsg } = this.state;

    if (loading) {
      return <LoadingSpinner text="Loading Page..." />;
    } else if (!!errMsg) {
      return <MainPage title={errMsg} />;
    } else if (!pageData) {
      return <MainPage title="No Page Found" />;
    }

    return (
      <MainPage title={pageData.Title}>
        <div className="p-4 container-fluid">
          <div dangerouslySetInnerHTML={{ __html: pageData.Html }} />
        </div>
      </MainPage>
    );
  }
}
